var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-popover",on:{"click":_vm.change}},[(_vm.visiable)?_c('div',{staticClass:"content-wrapper"},[_vm._t("content")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }